import React, { useState }          from "react";
import { MenuOutlined} from '@ant-design/icons';
import { Drawer, Badge  } from 'antd';
import './Header.less';

const Header = (props) => {

	const [visible, setVisible] = useState(false);
	const showDrawer = () => {
		setVisible(true);
	};
	const onClose = () => {
		setVisible(false);
	};

	let count = props.changes.length;

	return (
		<div className="header-app">
			<div className="header-wrapper">
				<div className="header-box">
					<div className="header-title">
						<span className="header-title-span" title="JSON Updater">JSON Updater</span>
					</div>
					<span className="header-btns">
						{props.buttons}
					</span>
					<span className="menu" onClick={showDrawer}>
						<Badge count={count}>
							<MenuOutlined style={{ fontSize: '32px', color: '#1890ff' }} />
						</Badge>
					</span>
				</div>
			</div>
			<Drawer
				title="Menu"
				placement="top"
				closable={true}
				onClose={onClose}
				visible={visible}
				onClick={onClose}
				height={250}
			>
				{props.buttons}
			</Drawer>
		</div>
	);
};

export default Header;